import React from 'react';
import { Box, TUILink, QuestionMarkIcon } from '../../ui';

const HelpButton = ({
  userId,
  isDark,
}: {
  userId: string;
  isDark?: boolean;
}) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        display: ['none', 'none', 'flex'],
        bottom: 12,
        right: 12,
      }}
    >
      <TUILink
        href={`https://standardresume.typeform.com/to/JHv1LTQt#id=${userId}`}
        target="_blank"
        data-testid="help-button"
        sx={{
          textDecoration: 'none',
          color: isDark ? 'blueDark' : 'blue',
        }}
      >
        <QuestionMarkIcon
          size={40}
          color={isDark ? 'white' : 'black'}
          sx={{
            width: 40,
            height: 40,
            borderRadius: 9999,
            backgroundColor: isDark ? 'buttonGrayDark' : 'buttonGray',
            transition: 'transform 200ms ease-in-out',
            ':hover': {
              transform: 'scale(1.2)',
            },
          }}
        />
      </TUILink>
    </Box>
  );
};

export default HelpButton;
